var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-hero hero", class: _vm.classes, style: _vm.background },
    [
      _c(
        "transition",
        { attrs: { name: _vm.transition, mode: "out-in", appear: "" } },
        [
          _c(
            _vm.heroComponent,
            _vm._b(
              { key: _vm.heroKey, tag: "component", class: _vm.classes },
              "component",
              _vm.heroData,
              false
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }